import React from "react";
import { dispatch } from "@rematch/core";
import _ from "lodash";
import { Form } from "formsy-semantic-ui-react";
import LoadingComponent from "../../../common/LoadingComponent";

import {
  Button,
  Header,
  Modal,
  Message,
  Grid,
} from "semantic-ui-react";

class ShowMetadata extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isJSONValid: true,
      updatedMetaDataSchema: this.props.preMetadata,
      loader: false
    };
  }

  close = () => {
    this.props.setMetaDataFlag(false);
  };
  IsValidJSONString = (e, data) => {
    try {
      JSON.parse(e.target.value);
    } catch (e) {
      this.setState({ isJSONValid: false });
      return false;
    }
    this.setState({
      isJSONValid: true,
      updatedMetaDataSchema: JSON.parse(e.target.value),
    });
    return true;
  };

  async saveUpdatedMetaData() {
    // Below changes for KLM-9001
    this.setState({loader: true})
    let payload = {
        _id: this.props.selectedSubOrg._id,
        metaData: this.state.updatedMetaDataSchema
    }
    dispatch.organizationUnit.updateSuborgMetadata(payload).then(() => {
      dispatch.organizationUnit.getSubOrgByIdAsync(payload._id)
      this.props.setMetaDataFlag(false);
      this.setState({loader: false})
    })
  }
  render() {
    const errorLabel = <div className="customErrorLabel" />;
    const {metaData} = this.props.selectedSubOrg

    return (
      <div>
      <LoadingComponent active={this.state.loader} message="Saving Metadata... " />
      <Modal
        open={this.props.open}
        onClose={this.close}
        size="small"
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Header
          content={`Manage Metadata `}
        />
        <Modal.Content>
          <Form
            noValidate
            ref={(ref) => (this.form = ref)}
            className="formcyForm"
            name="cretePack"
            id="cretePackID"
            onValidSubmit={(event) => {
              this.onSubmitNewTemplate(event);
            }}
          >
            <Grid>
              <Grid.Row>
                <Grid.Column width={16}>
                  <Form.TextArea
                    required
                    name="rule"
                    label="Metadata"
                    id="Condition"
                    onChange={(e, data) => this.IsValidJSONString(e, data)}
                    value={JSON.stringify(metaData, null , 4)}
                    errorLabel={errorLabel}
                    style={{ minHeight: "300px" }}
                    instantValidation
                  />
                  {!this.state.isJSONValid ? (
                    <Message
                      className="bg-warning"
                      style={{
                        float: "left",
                        padding: "8px",
                        width: "calc(100% - 200px)",
                        textAlign: "center",
                      }}
                      content="Please enter valid JSON"
                    />
                  ) : null}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            className="button-cancel"
            id="cancelSchema"
            onClick={this.close}
          >
            Close
          </Button>
          <Button
            className="button-submit"
            id="cancelSchema"
            onClick={() => this.saveUpdatedMetaData(this.state.updatedMetaDataSchema)}
            disabled={!this.state.isJSONValid ? true : false}
          >
            Save
          </Button>
        </Modal.Actions>
      </Modal>
      </div>
    );
  }
}

export default ShowMetadata;
